export default class UserControlController {
  constructor(AdminService, Notification, MasterService, $uibModal, ContentService, moment, $translate) {
    this.service = AdminService;
    this.notify = Notification;
    this.master = MasterService;
    this.modal = $uibModal;
    this.content = ContentService;
    this.moment = moment;
    this.trans = $translate.instant;
  }

  $onInit(){
    this.subscriptions = [];

    const _ = this.trans;
    this.admins = [];
    this.isMaster = this.master.isMasterAccount();
    this.translations = {
      ACTIVE: _('ACTIVA'),
      INACTIVE: _('INACTIVA')
    };

    this.subscriptions.push(
      this.accountsObservable.subscribe(
        (resp) => {
          this.accounts = resp.accounts.map(acc => {
            acc.isActive = acc.status === 'ACTIVE';
            return acc;
          });
        }
      )
    );

    this.adminLabel = {
      true: _('Administrador'),
      false: _('Usuario')
    };
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getOperativeAccounts(){
    this.subscriptions.push(
      this.accountsObservable.subscribe(
        (resp) => {
          this.accounts = resp.accounts.map(acc => {
            acc.isActive = acc.status === 'ACTIVE';
            return acc;
          });
        }
      )
    );
  };

  getAdminAccounts(){
    this.subscriptions.push(
      this.master.getAdminAccounts().subscribe(
        (resp) => {
          this.accounts = resp.accounts.map(acc => {
            acc.isActive = acc.status === 'ACTIVE';
            return acc;
          });
        }  
      )
    );
  };

  viewAccount(account){
    this.subscriptions.push(
      this.service.viewAccount(account).subscribe(
        (resp) => {
          this.account = resp;
          this.getAccountCollectors(resp);
          this.getAccountProfiles(resp);
          this.getAccountPointsOfSale(resp);
          this.getAccountDTTs(resp);
          this.getAccountBackups(resp);
        }
      )
    );
  }

  toggleAccountStatus(account) {
    this.subscriptions.push(
      this.service.toggleAccountStatus(account).subscribe(acc => {
        acc.isActive = acc.status === 'ACTIVE';
        this.accounts.splice(this.accounts.indexOf(account), 1, acc);
      })
    );
  }

  getClientKeys(account) {
    this.subscriptions.push(
      this.service.getClientKeys(account).subscribe(
        (clientKeys) => this.account.clientKeys = clientKeys
      )
    );
  }

  getAccountProfiles(account) {
    this.subscriptions.push(
      this.service.getAccountProfiles(account).subscribe(
        (profiles) => this.account.profiles = profiles
      )
    );
  }

  getAccountPointsOfSale(account) {
    this.subscriptions.push(
      this.service.getAccountPointsOfSale(account).subscribe(
        (points) => this.account.points = points
      )
    );
  }

  getAccountBackups(account) {
    this.subscriptions.push(
      this.service.getAccountBackups(account).subscribe(
        (data) => this.account.backups = data.backups
      )
    );
  }

  getAccountDTTs(account) {
    this.subscriptions.push(
      this.service.getAccountDTTs(account).subscribe(
        (data) => {
          let processed = data.processed.map((file) => {
            file.processed = true;
            return file;
          });
          let unprocessed = data.unprocessed.map((file) => {
            file.processed = false;
            return file;
          });
          let dtts = processed.concat(unprocessed).sort((a, b) => {
            return new Date(a).valueOf() - new Date(b).valueOf();
          });
          this.account.dtts = dtts;
        }
      )
    );
  }

  generateKey(account) {
    if (account) {
      this.subscriptions.push(
        this.service.generateClientKey(account).subscribe((resp) => this.getClientKeys(account))
      );
    }
  }

  removeKey(account, clientKey) {
    if (account) {
      this.subscriptions.push(
        this.service.removeClientKey(account, clientKey).subscribe(
          () => this.account.clientKeys.splice(this.account.clientKeys.indexOf(clientKey), 1)
        )
      );
    };
  }

  getAccountCollectors(account){
    this.subscriptions.push(
      this.service.getAllCollectors(account.id).subscribe(
        data => this.account.collectors = data.collectors,
        resp => console.log(resp)
      )
    );
  }

  openAdminAccountModal(){
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl:'admin-account-form.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance, $validation) => {
        "ngInject";
        $scope.adminInfo = {};
        $scope.createAdmin = () => {
          that.subscriptions.push(
            that.master.createAdminAccount($scope.adminInfo).subscribe(
              (data) => { $scope.closeThisDialog(); },
              (data) => {}
            )
          );
        };
        $scope.closeThisDialog = () => {
          $uibModalInstance.close();
        };
      }
    });
  }

  inviteUser(){
    const _ = this.trans;
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'invite-user-template.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance, $validation) => {
        "ngInject";
        $scope.emails = '';
        $scope.state = $state;
        $validation.setExpression({
          multiemail: /^$|^(([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\,(\s)?)?)+$/
        }).setDefaultMsg({
          multiemail: {
            error: _("No es un correo o listado de correos válido")
          }
        })
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.inviteUser = () => {
          that.subscriptions.push(
            that.content.inviteUser($scope.emails).subscribe(
              (resp) => {
                that.notify.success(_('Usuario invitado exitosamente.!'));
                $scope.state.reload();
                $scope.closeThisDialog();
              },
              (error) => {
                console.log(error);
              }
            )
          );
        };
      }
    });
  }

  openAssociationModal(aid){
    const _ = this.trans;
    var that = this;
    this.subscriptions.push(
      this.service.getAllCollectors().subscribe(
        data => {
          let collectors = data.collectors;
          this.modal.open({
            animation: true,
            size: 'lg',
            templateUrl: "collector-association-template.html",
            appendClassName: 'ngdialog-theme-plain',
            controller: ($scope, $state, $uibModalInstance, $validation) => {
              "ngInject";
              $scope.collectors = collectors;
              $scope.collectorChosen = collectors && collectors.length > 0 ? collectors[0].id : {};
              $scope.closeThisDialog = () => $uibModalInstance.close();
              $scope.associateCollector = (cid) => {
                if (!cid){
                  return;
                }

                that.subscriptions.push(
                  that.service.associateCollector(cid, aid).subscribe(
                    resp => { that.notify.success(_("Colector creado de manera exitosa.")); that.account.collectors.push(resp.collector); $scope.closeThisDialog(); },
                    resp => console.log(resp)
                  )
                );
              }
            }
          })
        }
      )
    );
  }


  openPointOfSaleCreationModal(pointOfSales){
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'point-of-sale-creation-modal.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance, $validation) => {
        "ngInject";
        $scope.pointOfSales = pointOfSales || {}
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.registerPOS = () => {
          that.subscriptions.push(
            that.service.registerPOS($scope.pointOfSales, that.account).subscribe(
              (newPos) => {
                that.account.points.push(newPos);
                $scope.closeThisDialog();              
              }
            )
          );
        };
        $scope.editPOS = () => {
          that.subscriptions.push(
            that.service.changePOS($scope.pointOfSales, that.account).subscribe(
              () => {
                $scope.closeThisDialog();          
              }
            )
          );
        };
      }
    });
  }
  
  openCollectorsModal(collectors){
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'collector-list-template.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance, $validation) => {
        "ngInject";
        $scope.collectors = collectors;
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.registerCollector = () => this.subscriptions.push(that.service.registerCollector().subscribe(
          data => { $scope.collectors.push(data.collector); }
        ));
        $scope.deleteCollector = (cid, idx) => this.subscriptions.push(that.service.deleteCollector(cid).subscribe(
          data => $scope.collectors.splice(idx, 1)
        ));
      }
    });
  }

  openAccountCollectorModal(collector){
    const _ = this.trans;
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'collector-modal.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance) => {
        "ngInject";
        $scope.collector = collector || {};

        $scope.posList = that.account.points.map(
          (pos) => {
            if ($scope.collector.hasOwnProperty('pos_list')){
              pos.observed = $scope.collector.pos_list.some(p => p.id === pos.id);
            } else {
              pos.observed = false;
            }
            pos.taken = that.account.collectors.filter(col => {
              if ($scope.collector){
                return $scope.collector.id != col.id;
              } else {
                return true;
              }
            }).filter(collector => 
               collector.pos_list.some(point => point.id === pos.id)
            ).length > 0;
            return pos;
          }
        );
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.togglePos = (pos, index) => {
          // TODO: Remove/Add from the current collector
          if (pos.observed) {
            that.subscriptions.push(
              that.service.observePOS($scope.collector, pos, that.account).subscribe((resp) => {
                if (!$scope.collector.pos_list) {
                  $scope.collector.pos_list = [];
                };
                $scope.collector.pos_list.push(pos);
                that.notify.success(_(`El colector estará ahora colectando datos del punto seleccionado.`));
              })
            );
          } else {
            that.subscriptions.push(
              that.service.unobservePOS($scope.collector, pos, that.account).subscribe(
                (resp) => {
                  $scope.collector.pos_list.splice($scope.collector.pos_list.indexOf(pos), 1);
                  that.notify.success(`${collector.name} ya no estará colectando datos de ${pos.name}.`);
                }
              )
            );
          }
        };
      }
    });
  }
  viewCollectorsList(){
    let that = this;
    this.subscriptions.push(
      this.service.getAllCollectors().subscribe(
        data => {
          that.openCollectorsModal(data.collectors);
        }
      )
    );
  }

  registerCollector(){
    const _ = this.trans;
    this.subscriptions.push(
      this.service.registerCollector().subscribe(
        (resp) => { this.notify.success(_("Colector creado de manera exitosa.")); },
        (resp) => {}
      )
    );
  }

  associateCollector(aid, cid){
    this.subscriptions.push(
      this.service.associateCollector(aid, cid).subscribe(
        (resp) => { console.log(resp); },
        (resp) => {}
      )
    );
  }

  disassociateCollector(acc, cid, idx){
    this.subscriptions.push(
      this.service.disassociateCollector(cid, acc.id).subscribe(
        resp => { acc.collectors.splice(idx, 1); },
        resp => { console.log(resp); }
      )
    );
  }

  deletePOS(pos, idx){
    this.subscriptions.push(
      this.service.deletePOS(pos, this.account).subscribe(
        resp => { this.account.points.splice(idx, 1); }
      )
    );
  }

  copySucceed() {
    const _ = this.trans;
    this.notify.success(_("El Client Key ha sido copiado al portapapeles"));
  }
  copyFailed(event) {
    const _ = this.trans;
    this.notify.warning(_(`No ha sido posible copiar el Client Key al portapapeles.`));
  }

  openDTTUploadModal(){
    const _ = this.trans;
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      appendClassName: 'ngdialog-theme-plain',
      templateUrl: 'dtt-upload-modal.html',
      controller: ($scope, $state, $uibModalInstance, FileUploader, host, AuthService, cfpLoadingBar) => {
        "ngInject";
        $scope.inMobileView = that.inMobileView;
        $scope.displayUploadedList = false;
        $scope.uploadedFiles = [];
        $scope.uploadingFiles = false;
        var fileUploader = $scope.fileUploader = new FileUploader({
          url: `${host}/api/admin/accounts/dtts`,
          headers: {
            Authorization: `Bearer ${AuthService.getToken()}`,
            'X-Account-Token': AuthService.getAccountToken()
          },
          formData: [
            { account_id: that.account.id }
          ],
        });
        fileUploader.onSuccessItem = (item, response, status, headers) => {
          var uploadedItem = {
            id: response.id,
            filename: response.filename,
            filesize: response.filesize,
            timestamp: that.moment.utc(response.timestamp).tz(
              this.accountService.timezone
            )
          };
          $scope.uploadedFiles.push(uploadedItem);
          that.account.backups.unshift(uploadedItem);
        };
        fileUploader.onErrorItem = (item, response, status, headers) => {
          that.notify.error(_("Ha ocurrido un error tratando de subir los archivos, intente nuevamente"));
          console.log("An error happened while uploading file");
        };
        fileUploader.onProgressAll = (progress) => {
          cfpLoadingBar.set(progress / 100);
        };

        fileUploader.onCompleteAll = () => {
          $scope.displayUploadedList = true;
          $scope.uploadingFiles = false;
          cfpLoadingBar.complete();
        };

        $scope.closeThisDialog = () => $uibModalInstance.close();

        $scope.uploadDtt = () => {
          if (fileUploader.queue.length > 0) {
            fileUploader.uploadAll();
            cfpLoadingBar.start();
            $scope.uploadingFiles = true;
          }
        };

      }
    });
  }

  openBackupUploadModal(){
    const _ = this.trans;
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      appendClassName: 'ngdialog-theme-plain',
      templateUrl: 'backup-upload-modal.html',
      controller: ($scope, $state, $uibModalInstance, FileUploader, host, AuthService, cfpLoadingBar) => {
        "ngInject";
        $scope.inMobileView = that.inMobileView;
        $scope.displayUploadedList = false;
        $scope.uploadedFiles = [];
        $scope.uploadingFiles = false;
        var fileUploader = $scope.fileUploader = new FileUploader({
          url: `${host}/api/admin/accounts/backups`,
          headers: {
            Authorization: `Bearer ${AuthService.getToken()}`,
            'X-Account-Token': AuthService.getAccountToken()
          },
          formData: [
            { account_id: that.account.id }
          ]
        });
        fileUploader.onSuccessItem = (item, response, status, headers) => {
          var uploadedItem = {
            id: response.id,
            filename: response.filename,
            filesize: response.filesize,
            title: response.title,
            timestamp: that.moment.utc(response.timestamp).tz(
              this.accountService.timezone
            )
          };
          $scope.uploadedFiles.push(uploadedItem);
          that.account.dtts.unshift(uploadedItem);
        };
        fileUploader.onErrorItem = () => {
          that.notify.error(_("Ha ocurrido un error tratando de subir los archivos, intente nuevamente"));          
        };
        fileUploader.onProgressAll = (progress) => {
          cfpLoadingBar.set(progress / 100);
        };

        fileUploader.onCompleteAll = (item, response, status, headers) => {
          $scope.displayUploadedList = true;
          $scope.uploadingFiles = false;
          cfpLoadingBar.complete();
        };
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.uploadBackup = () => {
          if (fileUploader.queue.length > 0) {
            fileUploader.uploadAll();
            cfpLoadingBar.start();
            $scope.uploadingFiles = true;
          }
        };
        $scope.clearQueue = () => { fileUploader.clearQueue(); };
      }
    });
  }

  processDTTs(){
    const _ = this.trans;
    this.subscriptions.push(
      this.service.processDTTs(this.account).subscribe(() => {
        this.notify.success(_("DTTs procesados de manera existosa."));
      })
    );
  }

}

 UserControlController.$inject = ['AdminService', 'Notification', 'MasterService', '$uibModal', 'ContentService', 'moment', '$translate'];



// WEBPACK FOOTER //
// ./src/app/pages/user-control/user-control.controller.js